import { ICON_REGISTRIES } from './unifiedIconRegistry.js';

/**
 * Renders an icon from the platform-approved icon libraries.
 *
 * Icons are loaded via an explicit registry (`unifiedIconRegistry.js`) so unused
 * Phosphor/Tabler icons are tree-shaken out of the production bundle.
 *
 * @param {import('./UnifiedIcon').UnifiedIconProps} props
 * @returns {JSX.Element | null}
 */
export function UnifiedIcon({
  name,
  library = 'phosphor',
  size = 24,
  color = 'currentColor',
  className = 'w-6 h-6',
  strokeWidth = 2,
  weight = 'light', // only applies to phosphor - previously 'regular'
  isActive = false,
  ...props
}) {
  const IconSet = ICON_REGISTRIES[library] || ICON_REGISTRIES.phosphor;
  const IconComponent = IconSet[name];

  if (!IconComponent) {
    console.warn(`[UnifiedIcon.jsx] Icon "${name}" not found in ${library}`);
    return null;
  }

  const updatedWeight = isActive ? 'fill' : weight;

  const extraProps =
    library === 'phosphor'
      ? { size, color, weight: updatedWeight }
      : { size, color, stroke: color, strokeWidth };

  return (
    <IconComponent
      data-testid={props['data-testid'] || 'components-unified-icon'}
      {...extraProps}
      className={className}
      {...props}
    />
  );
}

export default UnifiedIcon;
